import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { UtilitiesModule } from '../utilities/utilities.module';
import { EditTranslationComponent } from './edit-translation/edit-translation.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { ItemsListModule } from './items-list/items-list.module';
import { LIST_DATA, ListData, ListDataService } from './items-list/list-data.service';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { GlobalSearchService } from './global-search/global-search.service';
import { ColleaguesListComponent } from './colleagues-list/colleagues-list.component';
import { SystemNotificationsIconComponent } from './system-notifications-icon/system-notifications-icon.component';
import { HelpMenuComponent } from './help-menu/help-menu.component';
import { LoggedInUserComponent } from './logged-in-user/logged-in-user.component';
import { MainToolbarComponent } from './main-toolbar/main-toolbar.component';
import { PersonalNotificationsModule } from '../personal-notifications/personal-notifications.module';
import { MainMenuModule } from './main-menu/main-menu.module';
import { CommonService } from './common.service';
import { FiDisableLinksModule } from '@fi-app/shared/fi-directives/disable-links/disable-links.module';
import { ContentLanguageLabelModule } from './content-language-label/content-language-label.module';
import { FiStartPageLayoutModule } from './start-page-layout/start-page-layout.module';
import { FiLikesModule } from '../shared/ccm-likes/likes.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MediaBankFileUploadDetailModule } from '@fi-app/media-bank/media-bank-file-upload-detail/media-bank-file-upload-detail.module';
import { FiDialogSelectLanguageModule } from './dialog-select-language/dialog-select-language.module';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication';
import { UIRouterModule } from '@uirouter/angular';
import { MatListModule } from '@angular/material/list';
import { ExtendSharingModule } from '@fi-app/components/extend-sharing/extend-sharing.module';
import { MatInputModule } from '@angular/material/input';
import { FiSupportModule } from '@fi-shared/fi-support/fi-support.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiTextPanelModule } from '@fi-shared/fi-text-panel/fi-text-panel.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        UIRouterModule.forChild(),
        CommonModule,
        UtilitiesModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        ItemsListModule,
        MatMenuModule,
        PersonalNotificationsModule,
        MainMenuModule,
        FiDisableLinksModule,
        ContentLanguageLabelModule,
        FiStartPageLayoutModule,
        FiLikesModule,
        FiProfileIconModule,
        MatSelectModule,
        FiTextPanelModule,
        MediaBankFileUploadDetailModule,
        FiDialogSelectLanguageModule,
        FiEditPublicationModule,
        FiMenuItemSearchModule,
        MatListModule,
        ExtendSharingModule,
        MatInputModule,
        FiSupportModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiNameInputModule,
    ],
    declarations: [
        EditTranslationComponent,
        ProfileEditComponent,
        GlobalSearchComponent,
        ColleaguesListComponent,
        SystemNotificationsIconComponent,
        HelpMenuComponent,
        LoggedInUserComponent,
        MainToolbarComponent,
    ],
    exports: [
        EditTranslationComponent,
        ProfileEditComponent,
        ItemsListModule,
        ColleaguesListComponent,
        SystemNotificationsIconComponent,
        HelpMenuComponent,
        LoggedInUserComponent,
        MainToolbarComponent,
        MainMenuModule,
        FiDisableLinksModule,
        ContentLanguageLabelModule,
        FiStartPageLayoutModule,
        FiLikesModule,
        MediaBankFileUploadDetailModule,
        FiDialogSelectLanguageModule,
        FiEditPublicationModule,
        ExtendSharingModule,
    ],
    providers: [
        GlobalSearchService,
        ListDataService,
        {
            provide: LIST_DATA,
            useValue: ListData,
        },
        CommonService,
    ],
})
export class ComponentsModule {}
